var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#637DEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0219 2.81152V9.46334L17.6439 11.9761L12.0219 2.81152Z",
    fill: "#BECCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0219 2.81152L6.39673 11.9761L12.0219 9.46334V2.81152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.022 16.2881V20.8084L17.6472 13.0225L12.022 16.2881Z",
    fill: "#C0CCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0219 20.8081V16.2877L6.39673 13.0254L12.0219 20.8114V20.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.022 15.2419L17.6439 11.9763L12.022 9.4668V15.2419Z",
    fill: "#8098EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39673 11.9763L12.0219 15.2419V9.4668L6.39673 11.9763Z",
    fill: "#C0CCF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.2cf8d46f2ac7ee6a7dc06019d11ef19e.svg";
export { ForwardRef as ReactComponent };